<script>
import topNav from "../../package/topNav.vue";
import footNav from "../../package/footer.vue";
import agentSignInBox from "../../package/agentSignInBox.vue";
import advertisementSection from "../advertisementSection.vue";
import AgentSignIn from "../../package/agentSignIn.vue";
import reservationFormSection from "../reservationFormSection.vue";
import { mapActions } from "vuex";

export default {
  name: "selectionFormLayout",
  data() {
    return {
      adPage: "U-Display Listings Page",
      adSuburbs: "",
      adsData: "",
      showFootTxt: true,
      item: {},
      user: {},
      gray: true,
      num: 1,
      propertyId: this.$route.query.pid,
      privateMode: false,
    };
  },
  components: {
    AgentSignIn,
    advertisementSection,
    agentSignInBox,
    footNav,
    topNav,
    reservationFormSection
  },
  beforeUpdate() {
    document.title =
      "UNIFI Property: Reserve Property (" + this.$route.query.pid + ")";
  },
  created() {
    localStorage.removeItem("email");
    localStorage.removeItem("fname");
    localStorage.removeItem("sname");
    localStorage.removeItem("id");
    if (this.$route.path.slice(0,9) === '/private/') {
      this.privateMode = true;
    }
  },
  methods: {
    ...mapActions("property", [
      "getPropertyDetails",
    ]),
    propertyDetailsCallback(res) {
      console.log('propertyDetailsCallback: ', res)
      if (res.code == 0) {
        this.item = res.data;
      } else if (res.code == 90000 || 90002 || 90001) {
        localStorage.clear();
        this.$router.push("/login");
      } else if(res.code == 8902 || 8901) {
        this.$box.alert("", res.message, "error");
        localStorage.clear();
        this.$router.push("/login");
      } else {
        this.$box.alert("", res.message, "error");
      }
    }
  },
  mounted() {
    this.getPropertyDetails({
      params: {
        propertyId: this.$route.query.pid,
        roomId: this.$route.query.rid
      },
      callback: this.propertyDetailsCallback
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave called - selectionformlayout");
    this.$refs.$reservationFormSectionRef.destroy();
    next();
  }
};
</script>

<template>
  <el-container :lg="3" :md="4" :sm="6" :xl="1" :xs="8" class="mainWrapper">
    <el-header style="padding: 0">
      <top-nav v-bind:gray="gray" :privateMode="privateMode"></top-nav>
    </el-header>
    <el-main style="padding: 0; overflow: visible">
      <reservation-form-section
        ref="$reservationFormSectionRef"
        :listing-details="this.item"
      />
<!--      <advertisement-section-->
<!--        id="propertyReservation2ndPage"-->
<!--        :adLink="adsData.propertyReservation1Click"-->
<!--        :adUrl="adsData.propertyReservation1"-->
<!--      />-->
    </el-main>
    <el-footer style="padding: 0">
<!--      <agent-sign-in-box />-->
<!--      <agent-sign-in />-->
      <foot-nav :showQus="showFootTxt" :privateMode="privateMode"></foot-nav>
    </el-footer>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
  max-width: 1920px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/uConnectReservation/form/selectionFormLayout.vue